import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { stats } from "./mockdata/PatientData";
import StatCard from "../UI/StatCard";
import PatientsBreakdown from "../UI/PatientsBreakdown";
import PatientAdmission from "../UI/PatientAdmission";

import GenderDistribution from "../UI/GenderDistribution";
import OutAndInpatientGraph from "../UI/OutAndInpatientGraph";
import { get } from "../../utility/fetch";
// import SubmitFeedback from "./SubmitFeedback";

function Dashboard() {
  const user = localStorage.getItem("name");
  const navigate = useNavigate();
  const [assignedPatients, setAssignedPatients] = useState(0);
  const [allPatientCount, setAllPatientCount] = useState(0);

  const [outPatients, setOutpatients] = useState(0);
  const [waiting, setWaiting] = useState(0);
  const [admitted, setAdmitted] = useState(0);
  const [admittedPatients, setAdmittedPatients] = useState([]);
  const [hmoPatients, setHmoPatients] = useState(0);
  const [hmoPatientsList, setHmoPatientsList] = useState([]);
  const [gender, setGender] = useState({});
  const [summary, setSummary] = useState([0, 0, 0, 0, 0]);
  const [graph, setGraph] = useState({
    inPatientPercentage: 0,
    outPatientPercentage: 0,
    dailyAverageCount: [
      {
        date: "Mar 21",
        inPatientCount: 0,
        outPatientCount: 0,
      },
    ],
  });
  const [loading, setLoading] = useState(false);

  //done
  const getGraphDetails = async () => {
    try {
      const response = await fetch(
        "https://edogoverp.com/medicals/api/dashboard/AllOutPatientAndInPatientCount"
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      setGraph(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const getAllPatientCount = async () => {
    try {
      const data = await get(`/dashboard/AllPatientCount`, { status: 1 });
      setAllPatientCount(data);
      console.log(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const getGender = async () => {
    try {
      const data = await get(`/dashboard/gender`);
      setGender(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };
  const getAssigned = async () => {
    try {
      const data = await get(`/dashboard/assignedtodoctor`, { status: 1 });
      setAssignedPatients(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const getOutPatients = async () => {
    try {
      const data = await get(`/dashboard/AllOutPatientAndInPatientCount`);

      setOutpatients(data.outpatientCount || 0);
    } catch (e) {
      console.log("Error: ", e);
      setOutpatients(0);
    }
  };

  const getWaiting = async () => {
    try {
      const data = await get(`/dashboard/assignedtodoctor`, { status: 2 });

      setWaiting(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };
  const getAdmitted = async () => {
    try {
      const data = await get(`/dashboard/doctor/admittedpatients`);

      setAdmitted(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const getAllAdmittedPatients = async (page = 1, pageSize = 100) => {
    try {
      const res = await get(
        `/ServiceTreatment/list/paginate/true/admitted-patients?pageNumber=${page}&pageSize=${pageSize}`
      );
      setAdmittedPatients(res?.data?.recordList || []);
    } catch (error) {
      console.error("Error fetching admitted patients list:", error);
      setAdmittedPatients([]);
    }
  };

  //done
  const getHmoPatients = async () => {
    try {
      const data = await get(`/dashboard/hmo-patient`);

      setHmoPatients(data);
    } catch (e) {
      console.log("Error: ", e);
    }
  };

  const getHMOPatientsByClientId = async (pageIndex = 1, pageSize = 1000) => {
    try {
      const docInfo = JSON.parse(localStorage.getItem("USER_INFO"));
      const data = await get(
        `/HMO/all-patient-hmo/${docInfo.clinicId}?pageIndex=${pageIndex}&pageSize=${pageSize}`
      );
      console.log("HMO Patients List:", data);
      setHmoPatientsList(data.data);
    } catch (e) {
      console.log("Error fetching HMO patients list: ", e);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    await getAssigned();
    await getAdmitted();
    await getAllAdmittedPatients();
    await getAllPatientCount();
    await getHmoPatients();
    await getHMOPatientsByClientId();
    await getOutPatients();
    await getWaiting();
    await getGraphDetails();
    await getGender();
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setSummary([assignedPatients, admitted, hmoPatientsList?.length || 0, allPatientCount]);
  }, [assignedPatients, allPatientCount, waiting, admitted, hmoPatients, hmoPatientsList]);

  const handleStatClick = (stat) => {
    // choose a name field available on your stats objects
    const cardname = stat.title || stat.name || stat.label || String(stat);
    navigate(`/doctor/patients?cardname=${encodeURIComponent(cardname)}`);
  };

  return (
    <div className="w-100 m-t-80">
      {loading ? (
        <div className="loader">loading ...</div>
      ) : (
        <div className="m-t-20">
          <div>Good Day</div>
          <h3 className="m-t-10">Dr. {user}</h3>
          <div className="flex w-98 gap-8 space-between m-t-10">
            {" "}
            {stats.map((stat, index) => (
              <div
                style={{ backgroundColor: "white", cursor: "pointer" }}
                className="w-20"
                key={index}
                onClick={() => handleStatClick(stat)}
              >
                <StatCard
                  data={stat}
                  number={summary[index]}
                  icon={stat.icon}
                />
              </div>
            ))}
          </div>
          <div className="w-98 gap-16 flex">
            <div className="w-80 m-t-40">
              <OutAndInpatientGraph propdata={graph} />
              <div className="flex m-t-20 w-100">
                {/* <SubmitFeedback /> */}
                {/* <TrackFeedbackModal /> */}
                {/* <div className="m-r-20 w-50">
                  <PatientAdmission />
                </div>
                <div className="w-50">
                  <PatientsBreakdown />
                </div> */}
              </div>
            </div>
            <div className="w-20 m-t-40 m-r-20">
              <GenderDistribution propData={gender} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
